import React from 'react';
import { Box, Typography } from '@mui/material';
import appTheme from '../../../../../common/theme/appTheme.json';

const TransportPlansChartContainer = () => {
  return (
    <Box width="100%" height="auto" display="flex" justifyContent="center" alignItems="center">
      <Box
        width="97%"
        height="150px"
        borderRadius={5}
        bgcolor={appTheme.modalBackgroundColor}
        mt={3}
        mb={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography fontSize="16px" color="gray" textAlign="center">
          Transport Plans chart goes here ..
        </Typography>
      </Box>
    </Box>
  );
};

export default TransportPlansChartContainer;
